import { RuntimePracticeSessionScreen } from '@/features/unified-learning/runtime/screens/RuntimePracticeSessionScreen';

export default function LearnPracticeSessionRoute() {
  return <RuntimePracticeSessionScreen />;
}
